import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import './style.scss';

const LiveCounter = () => {
	const stateValue = useSelector( ( state ) => state );
	const { showLiveCounter, initialCounterValue } = stateValue;
	const [ count, setCount ] = useState( initialCounterValue );

	useEffect( () => {
		const interval = setInterval( () => {
			const randomIncrement = Math.floor( Math.random() * 10 ) + 1; // Generates a random number between 1 and 10
			setCount( ( prevCount ) => prevCount + randomIncrement );
		}, 1000 ); // Update every second.

		return () => {
			clearInterval( interval );
		};
	}, [] );

	// Function to wrap each character in a <span> with appropriate class.
	const formatNumber = ( number ) => {
		return number.split( '' ).map( ( char, index ) => {
			if ( char === ',' ) {
				return <span key={ index } className="st-sprtr">{ char }</span>;
			} else if ( ! isNaN( char ) ) {
				return <span key={ index } className="st-digit">{ char }</span>;
			}
			return char; // Handle any other characters as needed
		} );
	};

	return showLiveCounter
		? createPortal(
			<div className="st-counter">
				{ formatNumber( count.toLocaleString() ) }
			</div>,
			document.getElementById( 'astra-sites-evergreen-counter' )
		)
		: null;
};

export default LiveCounter;
